import lodashGet from 'lodash.get';

/**
 * Get object <e> property <name>.
 *
 * @param e
 * @param name
 * @returns property value or undefined
 */
const getProp = (e, name) => e.get ? e.get(name) : lodashGet(e, name);

/**
 * Get list item comparator for sort function.
 * compared items may be regular js objects or they may be ImmutableJS map.
 *
 * @param sortKey
 * @param ascending
 * @returns One of [-1, 0, 1]
 */
const getComparator = (sortKey, ascending) => (a, b) => {
  let fieldA = getProp(a, sortKey);
  let fieldB = getProp(b, sortKey);
  if(fieldA === undefined) {
    if(fieldB === undefined) {
      return 0;
    }
    else {
      fieldA = (typeof fieldB === 'number') ? 0 : '';
    }
  }
  else {
    if(fieldB === undefined) {
      fieldB = (typeof fieldA === 'number') ? 0 : '';
    }
  }
  let result = typeof fieldA === 'number' ?  ( ascending ? fieldA - fieldB : fieldB - fieldA) :  String(fieldA).toLocaleLowerCase().localeCompare(String(fieldB).toLocaleLowerCase());
  if(fieldA === fieldB) {
    result = String(a.name).toLocaleLowerCase().localeCompare(String(b.name).toLocaleLowerCase());
  }
  return  result;
};

export { getComparator, getProp };



// WEBPACK FOOTER //
// ./src/utils/listItemUtils.js